import { render } from "./FeedbackboardPhoneticVowel.vue?vue&type=template&id=51611f35&scoped=true"
import script from "./FeedbackboardPhoneticVowel.vue?vue&type=script&lang=js"
export * from "./FeedbackboardPhoneticVowel.vue?vue&type=script&lang=js"

import "@/css/components/feedbackboard-phonetic-vowel.css?vue&type=style&index=0&id=51611f35&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51611f35"]])

export default __exports__